/**
 * Action creator for creating a patient.
 *
 * Mirrors the inline action in the legacy `PatientCreateModal`:
 * PUT /accounts/:accountUuid/patients with the full patient body.
 * Server returns the created patient including `uuid`.
 *
 * The body shape is whatever the form orchestrator produces (DOB
 * UTC ISO, phones digits-only). This factory is contract-only — it
 * does not transform the body.
 */
const createPatientAction = ({ accountUuid, patient }) => ({
  method: 'PUT',
  endpoint: `/accounts/${accountUuid}/patients`,
  body: patient,
});

export default createPatientAction;
